import React, { Component } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { INGRESOS, EGRESOS } from "../../shared/IngresosEgresos";

import { ESTILOS } from './Styles/StylesBeca';

let indexIngresos = 0;
let indexIngresosVal = 0;
let totalIngresos = 0;
let control= false;
let indexEgresos = 0;
let totalEgresos = 0;
let controlE= false;

class PlanillaBecaPag3 extends Component {
    state = {
        addIngresos : [],
        addEgresos: [],
    }

    componentDidMount = () => {
        this.busquedaIngresos()
        this.busquedaEgresos()
    }

    busquedaIngresos = () => {
        let dataIn = JSON.parse(this.props.data3.ingresos_familia)
        let datos = []
        for (let i in dataIn) {
            let key = Object.keys(dataIn[i])[0];
            let cant = 0
            for (let n in INGRESOS){
                if (INGRESOS[n].nombre === key) cant++;
            }
            if (cant === 0) datos.push(dataIn[i])
        }

        control = true
        this.setState({
            addIngresos: datos
        })
    }

    busquedaEgresos = () => {
        let dataEg = JSON.parse(this.props.data3.egresos_familia)
        let datos = []
        for (let i in dataEg) {
            let key = Object.keys(dataEg[i])[0];
            let cant = 0
            for (let n in EGRESOS){
                if (EGRESOS[n].nombre === key) cant++;
            }
            if (cant === 0) datos.push(dataEg[i])
        }

        controlE = true
        this.setState({
            addEgresos: datos
        })
    }

    render() {
        const styles = StyleSheet.create(ESTILOS[0]);
        let { data3 } = this.props;

        let cantidad = (nombre) => {
            let { addIngresos } = this.state;
            let texto = "";

            if (nombre.nombre === "" && nombre.text === false && addIngresos.length > 0){
                let nomb = addIngresos[indexIngresosVal]
                indexIngresosVal ++;
                if (nomb !== undefined){
                    let keyName = Object.keys(nomb)
                    if (nomb[keyName] !== "") {
                        totalIngresos += parseInt(nomb[keyName]);
                        texto = "Bs."
                    }
                    return `${nomb[keyName]} ${texto}`;
                }
            }else{
                let data = JSON.parse(data3.ingresos_familia);
                let valor = ""
                for (let i in data) {
                    if (data[i][nombre.nombre] !== undefined && control === true)valor = data[i][nombre.nombre];
                }
                if (valor !== ""){
                    totalIngresos += parseInt(valor);
                    texto = "Bs."
                }
                return `${valor} ${texto}`; 
            } 
        }

        let cantidadE = (nombre) => {
            let { addEgresos } = this.state;
            let texto = "";

            if (nombre.text === false && addEgresos.length > 0){
                let item = addEgresos[indexEgresos]
                if (item !== undefined){
                    let keyName = Object.keys(item)
                    if (item[keyName] !== "") {
                        totalEgresos += parseInt(item[keyName]);
                        texto = "Bs."
                    }
                    return `${item[keyName]} ${texto}`;
                }
            }else{
                let data = JSON.parse(data3.egresos_familia);
                let valor = ""
                for (let i in data) {
                    if (data[i][nombre.nombre] !== undefined && controlE === true) valor = data[i][nombre.nombre];
                }

                if (valor !== ""){
                    totalEgresos += parseInt(valor);
                    texto = "Bs."
                }

                return `${valor} ${texto}`;
            }
        }

        let nombreIngreso = (nombre) => {
            let { addIngresos } = this.state;
            if (nombre.nombre === "" && nombre.text === false && addIngresos.length > 0){
                let nomb = addIngresos[indexIngresos]
                indexIngresos ++;
                if (nomb !== undefined) return Object.keys(nomb);
            }else{
                return nombre.nombre
            }
        }

        let nombreEgreso = (nombre) => {
            let { addEgresos } = this.state
            if (nombre.text === false && addEgresos.length > 0){
                let item = addEgresos[indexEgresos]
                if (item !== undefined) return `${nombre.nombre} ${Object.keys(item)}`
            }else{
                return nombre.nombre
            }
        }

        let familiaIE = () => (
            INGRESOS.map(option => (
                <View style={[styles.row]} key={option.id}>
                    <Text style={[styles.colTabla160, styles.font7, styles.bordeLRB]}>{nombreIngreso(option)}</Text>
                    <Text style={[styles.colTabla80, styles.font7, styles.bordeRB]}>{cantidad(option)}</Text>
                    <Text style={[styles.colTabla160, styles.font7, styles.bordeRB]}>{nombreEgreso(EGRESOS[option.id])}</Text>
                    <Text style={[styles.colTabla50, styles.font7, styles.bordeRB]}>{cantidadE(EGRESOS[option.id])}</Text>
                    <Text style={[styles.colTabla100, styles.font5, styles.bordeRB, styles.center]}></Text>
                </View>
            ))
        )

        let selectPreg = (idPreg, pregSelect) => {
            if (idPreg === pregSelect) return "X";
        }

        let opciones = (data, dataSelect) => {
            let num = 0
            return(
                data.map(option => {
                    num++;
                    return(
                        <View style={[styles.row]} key={option.id}>
                            <Text style={[styles.colTabla30, styles.font8, styles.bordeLRB, styles.center]}>{num}</Text>
                            <Text style={[styles.colTabla490, styles.font8, styles.bordeRB]}>{option.nombre_pregunta}</Text>
                            <Text style={[styles.colTabla30, styles.font8, styles.bordeRB, styles.center]}>{selectPreg(option.id, dataSelect)}</Text>
                        </View>
                    )
                })
            )
        }

        return (
            <React.Fragment>
                <View style={[styles.borde, styles.custonMt10, {backgroundColor: "#FFF", padding: 4,}]}>
                    <View style={[{padding: 1, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeAll, {backgroundColor: "#cecece", color:"#000"}]}>FAMILIA</Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 2}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla240, styles.font8, styles.bordeLRB, {backgroundColor: "#cecece", color:"#000"}]}>INGRESOS DEL GRUPO FAMILIAR</Text>
                            <Text style={[styles.colTabla210, styles.font8, styles.bordeRB, {backgroundColor: "#cecece", color:"#000"}]}>EGRESOS DEL GRUPO FAMILIAR</Text>
                            <Text style={[styles.colTabla100, styles.font5, styles.bordeRB, styles.center, {backgroundColor: "#cecece", color:"#000"}]}>GASTOS O EGRESOS PROPIOS</Text>
                        </View>
                        {familiaIE()}
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla160, styles.font7, styles.bordeLRB, {backgroundColor: "#cecece", color:"#000"}]}>TOTAL INGRESOS EN BS.</Text>
                            <Text style={[styles.colTabla80, styles.font7, styles.bordeRB]}>{`${totalIngresos} Bs.`}</Text>
                            <Text style={[styles.colTabla160, styles.font7, styles.bordeRB, {backgroundColor: "#cecece", color:"#000"}]}>TOTAL EGRESOS EN BS.</Text>
                            <Text style={[styles.colTabla50, styles.font7, styles.bordeRB]}>{`${totalEgresos} Bs.`}</Text>
                            <Text style={[styles.colTabla100, styles.font7, styles.bordeRB, styles.center, {backgroundColor: "#cecece", color:"#000"}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 2}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeAll, {backgroundColor: "#cecece", color:"#000"}]}>ESTUDIO SOCIO - ECONÓMICO</Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 1}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeAll, styles.center, {backgroundColor: "#cecece", color:"#000"}]}>¿CUAL ES LA OCUPACIÓN ACTUAL DEL JEFE DEL HOGAR?</Text>
                        </View>
                        {opciones(data3.pregunta1, data3.preg1_select)}
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 2}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeAll, styles.center, {backgroundColor: "#cecece", color:"#000"}]}>¿CUAL ES EL NIVEL EDUCATIVO DE LA CÓNYUGE O PAREJA DEL JEFE DEL HOGAR?</Text>
                        </View>
                        {opciones(data3.pregunta2, data3.preg2_select)}
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 2}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeAll, styles.center, {backgroundColor: "#cecece", color:"#000"}]}>¿CUAL ES LA PRINCIPAL FUENTE DE INGRESO DEL HOGAR?</Text>
                        </View>
                        {opciones(data3.pregunta3, data3.preg3_select)}
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 1}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeAll, styles.center, {backgroundColor: "#cecece", color:"#000"}]}>¿EN CUAL DE LAS SIGUIENTES CONDICIONES DE ALOJAMIENTO SE ENCUENTRA SU VIVIENDA?</Text>
                        </View>
                        {opciones(data3.pregunta4, data3.preg4_select)}
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla280, styles.font8, styles.bordeLRB, {backgroundColor: "#cecece", color:"#000"}]}>ESTRATO</Text>
                            <Text style={[styles.colTabla270, styles.font8, styles.bordeRB, {backgroundColor: "#cecece", color:"#000"}]}>TOTAL</Text>
                        </View>
                    </View>
                </View>
            </React.Fragment>
        );
    }
}
 
export default PlanillaBecaPag3;


// WEBPACK FOOTER //
// ./src/components/Reportes/PlanillaBecaPag3.jsx